import getEnv from 'helpers/getEnv';

export const MIN_PASSWORD_LENGTH = 8;

export const CONFIRM_SUCCESS_URL = getEnv('REACT_APP_BACKEND_URL');

export const IFRAME_ID = 'iframeID';

export const MIN_STRING_LENGTH = 10;
export const MIN_NAME_LENGTH = 3;

export const TEXT_LINK = 'text_link';
export const IMAGE_LINK = 'image_link';



// WEBPACK FOOTER //
// ./src/helpers/constants.js